import Title from '../../microComponents/elements/Title';
import ComponentCard from '../../microComponents/elements/ComponentCard';
import UseSetParams from '../../microComponents/tablePages/filter/UseSetParams';
import DeleteFilterTable from '../../microComponents/tablePages/filter/DeleteFilterTable';
import CreatorTable from '../../microComponents/tablePages/CreatorTable';
import UserManagementColumn from './UserManagementColumn';
import CreateEditUser from "./CreateEditUser";
import ShowSearchBtn from "../../microComponents/tablePages/ShowSearchBtn";
import React from "react";
import CollapseBox from "../../microComponents/tablePages/CollapseBox";
import {useSelector} from "react-redux";
import TopSearchUserManagement from "./TopSearchUserManagement";


const UserManagement = () => {
    const [columns] = UserManagementColumn();
    const [, handleDeleteParams] = UseSetParams();
    const showSearchBox = useSelector((state) => state.TableRedux.showSearchBox);

    return (<div>
            <ComponentCard>
                <div className='flex justify-between'>
                    <Title>مدیریت کاربرها
                    </Title>
                    <div className='flex gap-2 items-center'>
                        <DeleteFilterTable onClick={handleDeleteParams}/>
                        <CreateEditUser/>
                        <ShowSearchBtn/>
                    </div>
                </div>
                <div className='searchBox p-0'>
                    <CollapseBox activeKey={showSearchBox ? ['1'] : null} items={[{
                        showArrow: false, headerPadding: '1px', className: 'bg-white border-none',
                        key: '1', children: <TopSearchUserManagement/>,
                    }]}/>

                </div>
            </ComponentCard> <ComponentCard>
            {/*<CheckPermissionPage module='batch'>*/}

            <CreatorTable columns={columns} listAddress='Account'/>

            {/*</CheckPermissionPage>*/}
        </ComponentCard></div>
    );
};


export default UserManagement;